export default __webpack_public_path__ + "static/media/questionpack.43496b68.png";